import type { AxiosError } from 'axios'

import type {
  Api_Feed,
  Api_Feed_Video,
  Api_Playlist,
  Api_Playlist_Collection,
} from '@core/api'

export enum FeedType {
  USER_VIDEOS = 'user_videos',
  USER_TIMELINE = 'user_timeline',
  USER_TIMELINE_HASHTAG = 'user_timeline_hashtag',
  PLAYLIST = 'playlist',
  PRODUCT_SKU = 'product_skus',
  PLAYLIST_COLLECTION = 'playlist_collection',
}

type FeedSourceConfigBase = {
  username?: string
  firstVideoId?: string
  maxVideos?: number
  initialVideoId?: string
}

type FeedSourceUserTimelineConfig = FeedSourceConfigBase & {
  type: FeedType.USER_TIMELINE
}

type FeedSourceUserTimelineHashtagConfig = FeedSourceConfigBase & {
  type: FeedType.USER_TIMELINE_HASHTAG
  hashtagExpression: string
}

type FeedSourceProductSKUConfig = FeedSourceConfigBase & {
  type: FeedType.PRODUCT_SKU
  skus?: string
}

type FeedSourcePlaylistConfig = FeedSourceConfigBase & {
  type: FeedType.PLAYLIST
  playlistId?: string
}

type FeedSourcePlaylistCollectionConfig = FeedSourceConfigBase & {
  type: FeedType.PLAYLIST_COLLECTION
  playlistId?: string
}

type FeedSourceUserVideosConfig = FeedSourceConfigBase & {
  type: FeedType.USER_VIDEOS
  videoIds?: string[]
}

export type FeedSourceConfig =
  | FeedSourceUserTimelineConfig
  | FeedSourceUserTimelineHashtagConfig
  | FeedSourcePlaylistConfig
  | FeedSourcePlaylistCollectionConfig
  | FeedSourceProductSKUConfig
  | FeedSourceUserVideosConfig

export type FeedQuery = [
  {
    loading: boolean
    error: unknown
    videos: Api_Feed_Video[]
    playlists: Api_Playlist[]
    feed: Api_Feed | Api_Playlist_Collection | null
    config: FeedSourceConfig | null
  },
  {
    loadMore: (countOfNextVideos?: number) => Promise<void>
  },
]

export interface FeedQueryState {
  loading: boolean
  feed: Api_Playlist_Collection | null | Api_Feed
  error: Error | AxiosError | null
  config: FeedSourceConfig | null
}
